import { FaClock, FaMapMarkerAlt, FaUserTie, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaHourglass, FaTools, FaSearch, FaHammer, FaWater, FaSyncAlt, FaSun } from 'react-icons/fa';


// Function to render the appropriate icon based on the name
export const renderIcon = (iconName) => {

  // Convert the name to lowercase
  const lowercaseName = iconName.toLowerCase();

  // Check the lowercase name and return the corresponding icon component
  switch (lowercaseName) {

    /*----- Service Icons -----*/
    case 'roof installation':
      return <FaHammer />; // Hammer icon

    case 'roof repair':
      return <FaTools />; // Tools icon

    case 'roof inspection':
      return <FaSearch />; // Search icon

    case 'gutter installation':
      return <FaWater />; // Water drop icon

    case 'roof replacement':
      return <FaSyncAlt />; // Sync/refresh icon

    case 'skylight installation':
      return <FaSun />; // Sun icon

    /*----- Page Sidebar -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon

    case 'timing':
    case 'hours':
    case 'time':
      return <FaClock />; // Clock icon

    case 'duration':
      return <FaHourglass />; // Hourglass icon

    case 'client':
    case 'position':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
      return <FaMapMarkerAlt />; // Location icon

    case 'salary':
    case 'cost':
      return <FaDollarSign />; // Dollar icon

    case 'experience':
      return <FaBriefcase />; // Briefcase icon

    case 'leadarchitect':
      return <FaUserTie />; // Leader icon

    case 'number':
      return <FaPhone />; // Phone icon

    case 'email':
      return <FaEnvelope />; // Email icon

    default:
      return null; // Return null if no matching icon is found
  }

};